import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';

function useNavigate(config) {
  const { i18n } = useTranslation();
  const reactRouterNavigate = useReactRouterNavigate();

  const navigate = useCallback(
    (href, options) => {
      const basePath = config.basePath[i18n.language];
      const basePathTranslated = config.basePath[i18n.language === 'en' ? 'cy' : 'en'];

      if (basePath && typeof href === 'string' && href.startsWith(basePath)) {
        href = href.slice(basePath.length);
      }

      if (basePath && typeof href === 'string' && href.startsWith(basePathTranslated)) {
        href = href.slice(basePathTranslated.length);
      }

      return reactRouterNavigate(href, options);
    },
    [reactRouterNavigate]
  );

  return navigate;
}

export default useNavigate;
